import React from 'react';
import { Link } from 'react-router-dom';
import Helmet from 'react-helmet';

import MainLayout from '../layouts/MainLayout';
import ContentWrap from '../../components/global/ContentWrap';
import ContentHeader from '../../components/global/ContentHeader';
import LoginFormContainer from '../../containers/auth/LoginFormContainer';

// Temporary constant to determine whether to show sign up for PRO users.
const SHOW_PRO_SIGN_UP = false;

const LoginView = () => (
  <MainLayout>
    <Helmet>
      <title>Login &ndash; Waldo</title>
    </Helmet>

    <ContentWrap size="sm">
      <ContentHeader title="Login" />

      {SHOW_PRO_SIGN_UP ? (
        <p className="mb-5 text-sm">
          Don&rsquo;t have an account? <Link to="/auth/register">Sign up!</Link>
        </p>
      ) : (
        <p className="mb-5 text-sm">
          Sign in as a <Link to="/shutterbug/signin">Shutterbug</Link>
        </p>
      )}

      <LoginFormContainer />

      <p className="mb-0 mt-4 text-sm">
        Forgot your password? <Link to="/auth/password/reset">Click here!</Link>
      </p>
    </ContentWrap>
  </MainLayout>
);

export default LoginView;
